<template>
  <section>
    <el-card>
      <xp-searchbar class="approval-list-box" @search="handleGetData" @reset="handleReset">
        <el-form-item :label="$t('平台')" :label-width="$i18n.locale === 'zh-CN' ? '50px' : '70px'">
          <el-select clearable filterable v-model="commitData.platform" :placeholder="$t('请选择平台')">
            <el-option-group v-for="(group, index) in groupPlatformList" :key="index">
              <el-option v-for="item in group.options" :key="item.id" :disabled="!item.adminHasFlag"
                :label="$i18n.locale === 'zh-CN' ? item.platformName : item.platformNameEn"
                :value="item.platformId"></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <!-- <el-form-item :label="$t('流程类型')">
          <el-select :style="{width: '100%'}" clearable filterable v-model="commitData.onlyCc" :placeholder="$t('请选择流程类型')">
            <el-option :label="$t(item.label)" :value="item.value" :key="item.key" v-for="item in processTypeOptions"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item :label="$t('审批申请名称')" :label-width="$i18n.locale === 'zh-CN' ? '110px' : '190px'">
          <el-input v-model.trim="commitData.title" clearable :placeholder="$t('请输入审批申请名称')"></el-input>
        </el-form-item>
      </xp-searchbar>
    </el-card>
    <el-card>
      <el-table border size="mini" :data="tableData" style="width: 100%" v-loading="loadingData"
        :row-class-name="tableRowClassName" header-row-class-name="self-table-header">
        <el-table-column align="center" prop="id" label="ID" width="100"></el-table-column>
        <el-table-column align="center" prop="platform" :label="$t('所属业务平台')"></el-table-column>
        <el-table-column align="center" prop="title" :label="$t('审批申请名称')">
          <template slot-scope="scope">
            {{ approveTitleSet(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="state" :label="$t('状态')">
          <template slot-scope="scope">
            <span>{{ $t(Config.APPROVAL_STATUS[scope.row.state]) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="flowMode" :label="$t('审批模式')">
          <template slot-scope="scope">
            <span>{{ $t(Config.APPROVAL_MODEL[scope.row.flowMode]) }}</span>
          </template>
        </el-table-column>
        <!--        <el-table-column align="center" width="160" prop="status" :label="$t('保留状态')"></el-table-column>-->
        <el-table-column align="center" prop="applicant" :label="$t('发起人')"></el-table-column>
        <el-table-column align="center" prop="createTime" :label="$t('发起时间')">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | formatTimestamp }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="appName" :label="$t('操作')" align="center" width="100">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="goDetail(scope.row)">{{ $t('查看详情') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-container" v-if="dataTotal > commitData.pageSize && !loadingData">
        <el-pagination background layout="total, prev, pager, next" :page-size="commitData.pageSize" :total="dataTotal"
          :current-page="commitData.pageNo" @current-change="updatePages"></el-pagination>
      </div>
    </el-card>
  </section>
</template>

<script>
import Ajax from '@/ajax'
import Config from '@/config'
import { removeObjEmptyProperty, pureJsonClone, formatGroupPlatformList } from '@/utils'

export default {
  name: "approval_list",
  data () {
    return {
      Config,
      commitData: {
        pageNo: 1,
        pageSize: 30,
        title: '',
        platform: '',
      },
      activeId: null,
      loadingData: false,
      dataTotal: 0,
      tableData: [],
      groupPlatformList: [],
      processTypeOptions: [{
        value: false,
        label: '需我审批'
      }, {
        value: true,
        label: '需我知会'
      }],
    }
  },
  methods: {
    approveTitleSet (row) {
      let titleEn = '';
      if (row.extendInfo && JSON.parse(row.extendInfo)) {
        titleEn = JSON.parse(row.extendInfo).titleEn;
      }
      return this.$i18n.locale === 'zh-CN' ? row.title : (titleEn || row.title);
    },
    handleReset () {
      this.commitData = {
        pageNo: 1,
        pageSize: 50,
        title: '',
        platform: ''
      }
      this.handleGetData()
    },
    getPlatformList () {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)'
      });
      Ajax({
        url: '/admin/platform/login/list',
        method: 'get',
        params: {
          queryType: '1'
        }
      })
        .then(res => {
          this.platformList = res
          this.groupPlatformList = formatGroupPlatformList(res)
        })
        .catch(err => {
          this.$message.error(err || this.$t('服务器开小差'))
        })
        .finally(() => {
          loading.close();
        });
    },
    getEmail () {
      let userInfo = this.$store.state.userInfo;
      return userInfo ? userInfo.email : '';
    },
    handleGetData (refresh = true) {
      if (refresh) {
        this.commitData.pageNo = 1
      }
      let reqData = pureJsonClone(this.commitData)
      reqData.email = this.getEmail()
      reqData.historyListCheck = true
      this.loadingData = true
      reqData = removeObjEmptyProperty(reqData)
      Ajax({
        url: '/api/approve/list/paged',
        method: 'get',
        params: reqData
      })
        .then(data => {
          this.tableData = data.data || [];
          this.dataTotal = data.totalRecord
          this.loadingData = false
          this.filterQueryId();
        })
        .catch(err => {
          this.$message.error(err.message || err || this.$t('发起查询失败'))
          this.loadingData = false
        });
    },
    updatePages (n) {
      this.commitData.pageNo = n
      this.handleGetData(false)
    },
    goDetail (row) {
      let titleEn = '';
      if (row.extendInfo && JSON.parse(row.extendInfo)) {
        titleEn = JSON.parse(row.extendInfo).titleEn;
      }
      const info = {
        apId: row.id,
        title: row.title,
        titleEn: titleEn,
        state: row.state,
        bizId: row.bizId,
        platform: row.platform,
        applicant: row.applicant,
        createTime: row.createTime,
        approveTime: row.approveTime,
        applicantName: row.applicantName,
        applicantDesc: row.applicantDesc,
        flowMode: row.flowMode,
        approvalStatusVal: this.approvalStatusVal
      };
      this.$router.push({
        path: 'approval_history_detail',
        query: {
          info: btoa(encodeURIComponent(JSON.stringify(info)))
        }
      })
    },
    tableRowClassName ({ row }) {
      if (row.id.toString() === this.activeId) {
        return 'success-row'
      }
    },
    handleClick () {
      this.handleGetData();
    },
    filterQueryId () {
      // 邮箱地址跳转过来的 是已撤销审批的单子，它不在列表中，显示一个弹窗
      if (this.activeId && this.tableData.length) {
        const ele = this.tableData.find(obj => {
          return Number(obj.id) === Number(this.activeId);
        });
        if (!ele) {
          this.$alert(`当前工单（id:${this.activeId}）已撤回`, '', {
            confirmButtonText: '确定',
            callback: () => { }
          });
        }
      }
    }
  },
  mounted () {
    this.getPlatformList()
    this.handleGetData()
  },
  created () {
    this.activeId = this.$route.query.id
  },
  activated () {
    const refresh = this.$store.state.isRefreshApprovalList
    if (refresh) {
      this.handleReset(); // 重新请求数据
      this.$store.commit('setIsRefreshApprovalList', false)
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .success-row {
  background: rgb(240, 249, 235);
}
</style>
<style lang="scss">
.approval-list-box {
  .el-form-item {
    margin-bottom: 0 !important;
    width: auto !important;
  }
}
</style>
